import React, { useEffect } from "react";
import classNames from "classnames";
import { BemHelper } from "../utils/BemHelper";
import { useBreakpointValue } from "../utils";
import { truncateHtmlToPlainText } from "../utils/stringHelpers";
import defaultImage from "./images/default-product.jpeg";
import { Col, Row, Typography } from "antd";
import { CalendarIcon } from "../icons";

type Props = {
  title: string;
  createDate: string;
  description?: string;
  image?: string;
  actions?: React.ReactNode;
  onClick?: () => void;
  small?: boolean;
};

const bem = new BemHelper("article-card");

export const ArticleCard: React.FC<Props> = ({
  title,
  createDate,
  description,
  image,
  actions,
  onClick,
  small,
}) => {
  const isMobile = useBreakpointValue({ base: false, xs: true });
  const [date, setDate] = React.useState<string | null>(null);

  // fix for production env
  useEffect(() => {
    setDate(createDate);
  }, [createDate]);

  return (
    <Row
      onClick={() => onClick && onClick()}
      className={classNames(
        bem.block(),
        small && bem.modifier("small"),
        onClick && bem.modifier("has-actions"),
      )}
    >
      <div onClick={() => onClick && onClick()}>
        <div
          className={classNames(
            bem.element("image"),
            small && bem.modifier("small", "image"),
            isMobile && bem.element("image-mobile"),
          )}
          style={{ background: `url('${image || defaultImage}')` }}
        />
        {/* <img src={image || defaultImage} /> */}
      </div>

      <div
        className={classNames(
          bem.element("content"),
          small && bem.modifier("small", "content"),
          isMobile && bem.modifier("mobile-content"),
        )}
      >
        <Typography.Paragraph
          className={classNames(
            bem.element("title"),
            small && bem.modifier("small", "title"),
            actions && bem.modifier("short", "title"),
            isMobile && bem.modifier("mobile", "title"),
          )}
          ellipsis={{ rows: 2, expandable: false, symbol: "..." }}
          style={{ marginBottom: 0 }}
        >
          {title}
        </Typography.Paragraph>

        <div
          className={classNames(
            bem.element("create-date"),
            small && bem.modifier("small", "create-date"),
          )}
        >
          <CalendarIcon style={{ fontSize: small ? "16px" : "24px", marginRight: "9px" }} />
          {date}
        </div>

        {!isMobile && description && (
          <div
            className={classNames(bem.element("description"))}
            dangerouslySetInnerHTML={{ __html: truncateHtmlToPlainText(description, 120) }}
          />
        )}
      </div>

      {actions && (
        <Col span={6} className={classNames(bem.element("actions"))}>
          {actions}
        </Col>
      )}
    </Row>
  );
};
